import { ReduxAction } from './types';

export const TRANSFORM_SSR_STATE = 'TRANSFORM_SSR_STATE';
export type TransformSSRState<T> = ReduxAction<typeof TRANSFORM_SSR_STATE, T>;
